// extracted by mini-css-extract-plugin
module.exports = {"root":"Button-module--root--3u0ye","small":"Button-module--small--23fE-","primary":"Button-module--primary--lkUim","invert":"Button-module--invert--3dKax"};